module.exports = __webpack_public_path__ + "static/assets/58cfb18bfd91b5dc3ef1ab1c6f5b65e7.svg";